module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_3.e4c4a1d9.png";